import { render, staticRenderFns } from "./BudgetViewMentee.vue?vue&type=template&id=38c3db76&"
import script from "./BudgetViewMentee.vue?vue&type=script&lang=js&"
export * from "./BudgetViewMentee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports